import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import Divider from '@mui/material/Divider';
import { getCurrentUrl } from '../../services/ApiServices';
import ErrorAlert from '../../components/Error/Error';
import { Button, TextField } from '@mui/material';
import { Application } from '../../models/application';
import { request } from '../../interfaces/networkManager';
import { headers } from '../../services/genericConstantes';
import { ToastContainer, toast } from 'react-toastify';

export default function VariablesScreen() {
	const [applications, setApplications] = useState<Application[]>([]);
	const [applicationToUpdate, setApplicationToUpdate] = useState<Application | null>(null);
	const [error, setError] = useState<string | null>(null);
	const currentUrl: string = getCurrentUrl();

	const getApplications = async () => {
		const getOptions = {
			method: 'GET',
		};

		const apps: any = await request('/applications/', getOptions);
		if (apps?.error) setError('Erreur lors de la récupération des applications');
		else setApplications(apps);
	}

	const postUpdateApplication = async () => {
		if (applicationToUpdate === null) {
			toast.info('Aucune données n\'ont été modifiée', {
				position: 'bottom-center',
				theme: 'colored',
			});
			return;
		};
		const getOptions = {
			method: 'PUT',
			headers: headers(),
			body: JSON.stringify(applicationToUpdate),
		};
		fetch(`${getCurrentUrl()}/applications/${applicationToUpdate.id}`, getOptions)
			.then((response) => {
				if (response.ok) {
					toast.success('Mise à jour effectuée', {
						position: 'bottom-center',
						theme: 'colored',
					});
				}
				else {
					toast.error('Erreur lors de la mise à jour', {
						position: 'bottom-center',
						theme: 'colored',
					});
				}
			}).catch((error) => {
				setError(error.message);
			});
	}

	useEffect(() => {
		getApplications();
	}, [currentUrl]);

	return (
		<Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
			<Grid container spacing={1}>
				<Grid size={{ xs: 12 }}>
					<Grid container spacing={3}>
						<Grid size={{ sm: 12 }}>
							<Paper
								sx={{
									p: 2,
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<Typography component="h2" variant="h4" color={'primary'} gutterBottom sx={{ mb: 2 }}>
									Variables
								</Typography>
								<Grid container spacing={3}>
									{applications.map((application: Application) => (
										<Grid key={application.name} size={{ sm: 3 }}>
											<Paper component="form" sx={{ p: '2px 4px', m: '8px', display: 'flex', alignItems: 'center' }}>
												<Grid container spacing={3}>
													<Grid size={{ xs: 12 }}>
														<Typography variant="h5" style={{ textAlign: 'center' }}>
															{application.name}
														</Typography>
													</Grid>
													<Grid size={{ sm: 12 }}>
														<Grid container alignItems="center" padding={2}>
															<Grid size={{ xs: 4 }}>
																<Typography variant="body1" style={{ fontStyle: 'italic' }}>Version : </Typography>
															</Grid>
															<Grid size={{ xs: 8 }}>
																<TextField
																	size='small'
																	value={application.currentVersion}
																	fullWidth
																	onChange={(e) => {
																		setApplicationToUpdate({ ...application, currentVersion: e.target.value });
																		application.currentVersion = e.target.value;
																	}
																	}
																/>
															</Grid>
														</Grid>
													</Grid>
													<Grid size={{ sm: 12 }}>
														<Divider sx={{ m: 0.5 }} orientation="horizontal" />
													</Grid>
													<Grid size={{ sm: 12 }}>
														<Grid container alignItems="center">
															<Grid size={{ xs: 12 }}>
																<Typography variant='h6' style={{ textAlign: 'center' }}>
																	Appareils maximum
																</Typography>
															</Grid>
															<Grid size={{ xs: 12 }}>
																<Grid container alignItems="center" padding={2}>
																	<Grid size={{ xs: 4 }}>
																		<Typography variant="body1" style={{ fontStyle: 'italic' }}>Eleveur : </Typography>
																	</Grid>
																	<Grid size={{ xs: 8 }}>
																		<TextField
																			size='small'
																			value={application.nbDeviceMaxBreeder}
																			fullWidth
																			onChange={(e) => {
																				setApplicationToUpdate({ ...application, nbDeviceMaxBreeder: Number(e.target.value) });
																				application.nbDeviceMaxBreeder = Number(e.target.value);
																			}
																			}
																		/>
																	</Grid>
																</Grid>
															</Grid>
															<Grid size={{ xs: 12 }}>
																<Grid container alignItems="center" padding={2}>
																	<Grid size={{ xs: 4 }}>
																		<Typography variant="body1" style={{ fontStyle: 'italic' }}>Technicien : </Typography>
																	</Grid>
																	<Grid size={{ xs: 8 }}>
																		<TextField
																			size='small'
																			value={application.nbDeviceMaxPHF}
																			fullWidth
																			onChange={(e) => {
																				setApplicationToUpdate({ ...application, nbDeviceMaxPHF: Number(e.target.value) });
																				application.nbDeviceMaxPHF = Number(e.target.value);
																			}
																			}
																		/>
																	</Grid>
																</Grid>
															</Grid>
														</Grid>
													</Grid>
													<Grid size={{ xs: 12 }}>
														<Divider sx={{ m: 0.5 }} orientation="horizontal" />
													</Grid>
													<Grid size={{ sm: 12 }} padding={2} style={{ textAlign: 'center' }}>
														<Button variant='contained' onClick={() => postUpdateApplication()}>
															Mettre à jour
														</Button>
													</Grid>
												</Grid>
											</Paper>
										</Grid>
									))}
								</Grid>
								{error ? (<Grid size={{ sm: 12 }}><ErrorAlert message={error} /></Grid>) : null}
							</Paper>
						</Grid>
					</Grid>
				</Grid>
				<ToastContainer />
			</Grid>
		</Container>
	);
}
